<template>
  <a-config-provider :locale="locale">
    <a-style-provider hash-priority="high">
      <div id="app">
        <router-view />
      </div>
    </a-style-provider>
  </a-config-provider>
</template>

<script setup>
import { watch } from 'vue'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import zhCN from 'ant-design-vue/es/locale/zh_CN'

dayjs.locale('zh-cn')

const locale = zhCN
</script>

<style lang="scss">
#app {
  width: 100vw;
  height: 100vh;
  font-size: 14px;
  overflow-x: hidden;
}

.container_body {
  width: 100%;
  height: 100%;
  background: #eee;
  // overflow-y: auto;
}

.container_body_box {
  width: 100%;
  height: auto;
  background: #fff;
  border-radius: 8px;
}
</style>
